import React, { useState } from 'react';
import './Commety.scss';

function Commety(props) {
  return <button className="btn btn-commety">{props.title}</button>;
}

export default Commety;
